import { Button } from "@material-ui/core";
import ArrowBackIosIcon from "@material-ui/icons/ArrowBackIos";
import React from "react";

export default ({ backToTable, text, disabled }) => {
  const btnTxt = text || "VOLTAR";

  return (
    <Button
      style={{ padding: "11px 11px 8px", alignItems: "center" }}
      disabled={disabled}
      className="qd-back-btn"
      size="large"
      onClick={backToTable}
      startIcon={<ArrowBackIosIcon />}
      variation="outlined"
    >
      {btnTxt}
    </Button>
  );
};
